import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'emp-profile-dialog',
  templateUrl: 'emp-profile-dialog.html',
  styleUrls: ['./emp-profile-dialog.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, FormsModule, ReactiveFormsModule],
})
export class EmpProfileDialog {
  constructor(public dialogRef: MatDialogRef<EmpProfileDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(){
    console.log('data', this.data);
    
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
